import init from '../../common/base/init';

init(() => {
  if (!document.querySelector('.inner-tabs__item')) return;

  const tabButtons = document.querySelectorAll('.inner-tabs__item');
  const allTabsContent = document.querySelectorAll('.service-tab-content');

  tabButtons.forEach((tabEl) => {
    tabEl.onclick = () => {
      tabButtons.forEach(_tabEl => _tabEl.classList.remove('tab-item-selected'));
      tabEl.classList.add('tab-item-selected');

      allTabsContent.forEach((tabContent) => {
        tabContent.style.display = 'none';
      })

      const selectedTabContent = document.querySelector(`.seminar-${tabEl.id}`);
      if (!selectedTabContent) {
        allTabsContent[allTabsContent.length - 1].style.display = 'block';
      } else {
        selectedTabContent.style.display = 'block';
      }
    }
  });
});
